import { Component, Inject, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';
import { CutoffService } from 'src/app/services/cutoff.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InventorysService } from 'src/app/services/inventory.service';
import { ProjectDiagramationImportSummaryComponent } from '../project-diagramation-import-summary/project-diagramation-import-summary.component';
import { ProjectDiagramationImportVobosComponent } from '../project-diagramation-import-vobos/project-diagramation-import-vobos.component';

@Component({
  selector: "app-project-diagramation-import",
  templateUrl: "./project-diagramation-import.component.html",
  styleUrls: ["./project-diagramation-import.component.scss"],
})
export class ProjectDiagramationImportComponent implements OnInit {
  diagrams: any[] = [];
  projectAllDiagramations: any[] = [];
  fileName: string = "";
  isLoading: boolean = false;
  stopOnError: boolean = false;
  isImporting: boolean = false;
  importCompleted: boolean = false;
  initialLoading: boolean = true;
  initialDataReady: boolean = false;
  form!: FormGroup;
  medios: any[] = [];
  filteredMedios: any[] = [];
  selected_medios: any[] = [];
  project: any; //ProjectData
  promos: any[] = [];
  phases: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private main: MainService,
    private projectsS: ProjectsService,
    private dialogRef: MatDialogRef<ProjectDiagramationImportComponent>,
    private _cutoffS: CutoffService,
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private inventoryService: InventorysService
  ) {
    this.selected_medios = this.data.selected_medios;
    this.project = this.data.projectData;
    this.phases = this.data.phases;
    console.log("Phases:", this.phases);
    this.projectAllDiagramations = this.data.projectAllDiagramations;
  }

  ngOnInit(): void {
    this.loadForm();
    void this.loadInitialData();
  }

  async loadInitialData() {
    this.initialLoading = true;
    this.initialDataReady = false;
    try {
      const [promoData] = await Promise.all([
        this.projectsS.getPromotionData(this.data.id_proy_camp).toPromise(),
        this.getMedios()
      ]);
      this.promos = promoData.data || [];
      this.initialDataReady = true;
    } catch (error) {
      console.error("Error loading import data", error);
      Swal.fire("Error", "No se pudieron cargar los datos necesarios para la importación. Por favor, cierre e intente de nuevo.", "error");
    } finally {
      this.initialLoading = false;
    }
  }

  loadForm() {
    this.form = this.fb.group({
      blob: [null, Validators.required]
    });
  }
  // ajusta el contenedor sin cerrar ni volver a abrir el modal

  private updateDialogSize(hasFile: boolean): void {
    this.dialogRef.removePanelClass(["dialogs-md", "dialogs-xl"]);
    this.dialogRef.addPanelClass(hasFile ? "dialogs-xl" : "dialogs-md");
  }

  onValueChange(files: File[]) {
    if (files.length > 1) {
      Swal.fire("Error", "Solo puede seleccionar un archivo a la vez.", "error");
      this.resetFile();
      return;
    }
    if (files.length === 0) {
      return;
    }
    const file = files[0];
    if (this.isImporting || !this.initialDataReady)
      return;
    if (file && (file.type === "application/json" || /\.json$/i.test(file.name))) {
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonContent = JSON.parse(reader.result as string);
          if (!Array.isArray(jsonContent) || jsonContent.length === 0) {
            throw new Error("El archivo debe contener una lista de diagramaciones.");
          }
          this.diagrams = jsonContent.map((d: any, index: number) => {
            this.validateImportedRecord(d);
            const mappedVobos = this.mapImportedVobos(d.config_vobos || []);
            return {
              ...d,
              sucursales: [...new Set(d.sucursales.map((id: any) => Number(id)))],
              posicion: d.posicion == null ? 1 : Number(d.posicion),
              config_vobos: mappedVobos.config,
              vobosMappingValid: mappedVobos.isComplete,
              id: "temp-" + index + "-" + Date.now(),
              savedId: null,
              status: "pending",
              alerts: [],
              error: null,
              isSaving: false,
              vobosAreValid: false
            };
          });
          this.updateDialogSize(true);
          this.processImportedData();
        } catch (error) {
          this.main.HideLoading();
          Swal.fire("Error", "El archivo JSON no es válido.", "error");
          this.resetFile();
        }
      };
      reader.readAsText(file);
    }
    else {
      this.main.HideLoading();
      Swal.fire("Error", "Por favor, selecciona un archivo .json válido.", "error");
      this.resetFile();
    }
  }

  private mapImportedVobos(importedConfig: any[]): {
    config: any[];
    isComplete: boolean;
  } {
    let isComplete = true;
    const config = this.phases.map((phase: any) => {
      const importedPhase = importedConfig.find((configPhase: any) => this.normalizeName(configPhase.name) === this.normalizeName(phase.name));
      if (!importedPhase)
        isComplete = false;
      return {
        id: phase.id,
        vobos: phase.vobos.map((vobo: any) => {
          const importedVobo = importedPhase?.vobos?.find((configVobo: any) => this.normalizeName(configVobo.area) === this.normalizeName(vobo.area));
          if (!importedVobo)
            isComplete = false;
          const importedUserIds = new Set((importedVobo?.users || []).map((userId: any) => Number(userId)));
          const users = vobo.users
            .filter((user: any) => importedUserIds.has(Number(user.id)))
            .map((user: any) => user.id);
          if (users.length !== importedUserIds.size)
            isComplete = false;
          return {
            id: vobo.id,
            users,
            area: vobo.area,
            optional: vobo.optional
          };
        })
      };
    });
    return { config, isComplete };
  }

  private normalizeName(value: any): string {
    return String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  }

  private validateImportedRecord(diagram: any): void {
    if (!diagram || typeof diagram !== "object" ||
      !Array.isArray(diagram.promociones) || !Array.isArray(diagram.sucursales) ||
      (diagram.config_vobos != null && (!Array.isArray(diagram.config_vobos) ||
        diagram.config_vobos.some((phase: any) => !phase || !Array.isArray(phase.vobos) ||
          phase.vobos.some((vobo: any) => !vobo || !Array.isArray(vobo.users))))) ||
      diagram.sucursales.some((id: any) => !Number.isInteger(Number(id)) || Number(id) <= 0) ||
      (diagram.posicion != null && (!Number.isInteger(Number(diagram.posicion)) || Number(diagram.posicion) < 1))) {
      throw new Error("La estructura de la diagramación no es válida.");
    }
  }

  isDiagramSaved(diagram: any): boolean {
    return diagram.savedId != null || diagram.status === "completed" || diagram.status === "alerts";
  }

  private availablePops(pops: any[], medioId: any): any[] {
    return pops.filter(pop => {
      const positions = new Set(this.projectAllDiagramations
        .filter(d => Number(d.id_medio) === Number(medioId) && Number(d.id_pop) === Number(pop.id))
        .map(d => Number(d.posicion)));
      return !Number(pop.posiciones) || positions.size < Number(pop.posiciones);
    });
  }

  resetFile() {
    this.isImporting = false;
    this.importCompleted = false;
    this.fileName = "";
    this.diagrams = [];
    this.form.reset();
    this.updateDialogSize(false);
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.diagrams, event.previousIndex, event.currentIndex);
  }

  discardDiagram(index: number) {
    this.diagrams.splice(index, 1);
    // si se descartan todos resetear la vista.
    if (this.diagrams.length === 0)
      this.resetFile();
  }
  hasPositions: boolean = false;

  getMedios(): Promise<void> {
    this.hasPositions = false;
    return new Promise((resolve, reject) => {
      this.projectsS.getMedios(this.data.id_proy_camp).subscribe({
        next: (x: any) => {
          this.medios = x.data.medios;
          this.filteredMedios = this.filterMedios();
          resolve();
        },
        error: (err: any) => {
          console.error("Error loading medios", err);
          reject(err);
        }
      });
    });
  }

  filterMedios() {
    return this.medios.filter((x: any) => this.selected_medios.some(id => Number(id) === Number(x.id)));
  }

  async processImportedData() {
    this.isLoading = true;
    try {
      for (const diagram of this.diagrams) {
        await this.onMedioChange(diagram, diagram.medio);
        this.validateVobos(diagram);
      }
    } finally {
      this.isLoading = false;
    }
  }

  async onMedioChange(diagram: any, medioIdentifier: string | number, newMedio: boolean = false) {
    diagram.medioError = null;
    diagram.popError = null;
    diagram.positionError = null;
    diagram.pop_id = null;
    diagram.pop_sel = null;
    diagram.medio_sel = null;
    diagram.availablePops = [];
    diagram.availablePositions = [];
    this.validateVobos(diagram);
    let medio: any;
    if (typeof medioIdentifier === "string") {
      medio = this.filteredMedios.find(m => this.normalizeName(m.nombre) === this.normalizeName(medioIdentifier));
    }
    else {
      medio = this.filteredMedios.find(m => Number(m.id) === Number(medioIdentifier));
    }
    if (!medio) {
      diagram.medioError = medioIdentifier != null ? "Medio \"" + medioIdentifier + "\" no encontrado o no disponible." : "Escriba un medio válido";
      diagram.medio_id = null;
      return;
    }
    diagram.medio_id = medio.id;
    diagram.medio_sel = { ...medio, formato: Number(medio.formato), inventario_type: Number(medio.inventario_type) };
    diagram.medio = medio.nombre;
    if (newMedio) {
      diagram.pop = "";
      diagram.posicion = 1;
    }
    await this.loadPopsForMedio(diagram);
  }

  async loadPopsForMedio(diagram: any) {
    if (!diagram.medio_id)
      return;
    try {
      const x: any = await this.projectsS.getPOPs(diagram.medio_id).toPromise();
      diagram.cant_pops = x.data.elementos_pop.length;
      diagram.availablePops = this.availablePops(x.data.elementos_pop, diagram.medio_id);
      await this.onPopChange(diagram, diagram.pop);
    } catch (error) {
      console.error("Error loading POPs for medio:", diagram.medio_id, error);
      diagram.popError = "Error al cargar elementos POP.";
    }
  }

  async onPopChange(diagram: any, popIdentifier: string | number) {
    diagram.popError = null;
    diagram.positionError = null;
    diagram.availablePositions = [];
    diagram.pop_id = null;
    diagram.pop_sel = null;
    this.validateVobos(diagram);
    let pop: any;
    if (typeof popIdentifier === "string") {
      pop = diagram.availablePops.find((p: any) => this.normalizeName(p.nombre) === this.normalizeName(popIdentifier));
    }
    else {
      pop = diagram.availablePops.find((p: any) => Number(p.id) === Number(popIdentifier));
    }
    if (!pop) {
      diagram.popError = popIdentifier ? "POP \"" + popIdentifier + "\" no encontrado o no disponible para este medio." : "Escriba un POP válido";
      diagram.pop_id = null;
      return;
    }
    diagram.pop_id = pop.id;
    diagram.pop_sel = pop;
    diagram.pop = pop.nombre;
    diagram.posicion = Number(diagram.posicion);
    if (pop.posiciones > 0) {
      const diagramedPositions = this.projectAllDiagramations
        .filter((x: any) => x.id_medio == diagram.medio_id && x.id_pop == diagram.pop_id)
        .map((p: any) => Number(p.posicion));
      const allPositions = Array.from({ length: pop.posiciones }, (_, i) => i + 1);
      diagram.availablePositions = allPositions.filter(p => !diagramedPositions.includes(p));
      if (!diagram.availablePositions.includes(diagram.posicion)) {
        diagram.positionError = "Posición " + diagram.posicion + " no disponible.";
      }
    }
  }

  onPositionChange(diagram: any) {
    if (diagram.availablePositions.includes(diagram.posicion)) {
      diagram.positionError = null;
    }
    else {
      diagram.positionError = "Posición " + diagram.posicion + " no disponible.";
    }
    this.validateVobos(diagram);
  }

  openVobosModal(diagram: any) {
    this.matDialog.open(ProjectDiagramationImportVobosComponent, {
      panelClass: ["dialogs-xl"],
      data: {
        diagram: diagram,
        phases: this.phases,
        project: this.project
      }
    }).afterClosed().subscribe((resp) => {
      if (resp) {
        diagram.config_vobos = resp;
        diagram.vobosMappingValid = true;
        this.validateVobos(diagram);
      }
    });
  }

  validateVobos(diagram: any) {
    if (diagram.vobosMappingValid === false || !diagram.config_vobos || diagram.config_vobos.length !== this.phases.length) {
      diagram.vobosAreValid = false;
      return;
    }
    diagram.vobosAreValid = diagram.config_vobos.every((phase: any) => phase.vobos.every((vobo: any) => vobo.optional || (vobo.users && vobo.users.length > 0)));
  }

  get areAllDiagramsValid(): boolean {
    const pending = this.diagrams.filter(d => !this.isDiagramSaved(d));
    if (!this.initialDataReady || this.isLoading || pending.length === 0)
      return false;
    return pending.every(d => d.medio_id &&
      d.pop_id &&
      !d.medioError &&
      !d.popError &&
      !d.positionError &&
      d.vobosAreValid);
  }

  get hasPendingDiagrams(): boolean {
    return this.diagrams.some(d => !this.isDiagramSaved(d));
  }

  importDiagrams() {
    if (this.isImporting || !this.areAllDiagramsValid)
      return;
    const diagramsToImport = this.diagrams.filter(d => !this.isDiagramSaved(d));
    const count = diagramsToImport.length;
    Swal.fire({
      title: "Confirmar importación",
      html: "Se importarán <strong>" + count + "</strong> registro(s).<br>Al comenzar el proceso la ventana no podrá cerrarse, si esto sucede, el proceso se cancelará.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false
    }).then(async (result) => {
      if (result.isConfirmed && !this.isImporting) {
        this.isImporting = true;
        this.dialogRef.disableClose = true;
        try {
          for (const diagram of diagramsToImport) {
            diagram.isSaving = true;
            diagram.status = "importing";
            diagram.alerts = [];
            diagram.error = null;
            try {
              this.validateImportedRecord(diagram);
              await this.refreshDataDiagramationAsync();
              await this.onMedioChange(diagram, diagram.medio);
              if (diagram.medioError || diagram.popError || diagram.positionError || !diagram.vobosAreValid) {
                throw new Error(diagram.medioError || diagram.popError || diagram.positionError || "Configuración de VoBos incompleta.");
              }
              // validar promociones disponibles en el proyecto
              const validPromos = diagram.promociones.filter((p: any) => this.promos.some((promo: any) => promo["CODIGO PRINCIPAL"] == p));
              const invalidPromos = diagram.promociones.filter((p: any) => !this.promos.some((promo: any) => promo["CODIGO PRINCIPAL"] == p));
              if (invalidPromos.length > 0) {
                diagram.alerts.push("Las siguientes promociones no se encontraron y fueron omitidas: " + invalidPromos.join(", "));
              }
              if (validPromos.length === 0)
                throw new Error("Debe existir al menos una promoción válida para importar.");
              const { stores_sel, alerts, dt_totales } = await this.processSucursalesForDiagram(diagram);
              diagram.alerts.push(...alerts);
              if (stores_sel.length === 0) {
                throw new Error("Ninguna de las sucursales especificadas en el JSON pudo ser seleccionada o no se especificaron sucursales.");
              }
              let positionToSave = diagram.posicion || 1;
              if (!diagram.pop_sel.posiciones || diagram.pop_sel.posiciones == 0) {
                const positions = this.projectAllDiagramations
                  .filter((e: any) => Number(e.id_medio) === Number(diagram.medio_id) && Number(e.id_pop) === Number(diagram.pop_id))
                  .map((e: any) => Number(e.posicion));
                positionToSave = positions.length > 0 ? Math.max(...positions) + 1 : 1;
              }
              const ins_data = {
                id_proyecto: this.data.id_proy,
                medio: diagram.medio_id,
                elemento_pop: diagram.pop_id,
                position: positionToSave,
                alias: diagram.alias,
                promociones: validPromos,
                imprime: true,
                fases: diagram.config_vobos,
                sucursales: stores_sel,
                precios: dt_totales
              };
              const validationResult = await this.validarGuardado(diagram, ins_data);
              if (!validationResult.isValid) {
                diagram.alerts.push(validationResult.message);
                throw new Error(validationResult.message);
              }
              const result: any = await this.projectsS.newProjectDiagram(ins_data).toPromise();
              if (result.message !== "Success") {
                throw new Error(result.error_msg || "Error desconocido al guardar la diagramación.");
              }
              diagram.savedId = result.id_diagrama;
              const revalidationResult = await this.revalidarGuardado(diagram, ins_data, result.id_diagrama);
              if (!revalidationResult.isValid) {
                const deletion: any = await this.projectsS.deleteProjectDiagram(result.id_diagrama).toPromise();
                if (deletion.message !== "Success")
                  throw new Error("No se pudo revertir el guardado. Verifique la diagramación antes de reintentar.");
                diagram.savedId = null;
                throw new Error(revalidationResult.message);
              }
              diagram.status = diagram.alerts.length > 0 ? "alerts" : "completed";
            } catch (error: any) {
              diagram.status = "error";
              diagram.error = error.message || "Ocurrió un error inesperado.";
              if (diagram.savedId != null) {
                diagram.error = "La diagramación " + diagram.savedId + " fue guardada, pero no se pudo confirmar o revertir. Verifique el proyecto antes de reintentar. " + diagram.error;
              }
              if (this.stopOnError) {
                break; // parar
              }
            } finally {
              diagram.isSaving = false;
            }
          }
        } finally {
          this.isImporting = false;
          this.importCompleted = true;
          this.dialogRef.disableClose = false;
        }
        this.showSummary();
      }
    });
  }

  async getInventoryForDiagram(medio_sel: any, pop_sel: any): Promise<{
    dt_totales: any[];
    dt_totales_validation: any[];
  }> {
    let filtros_sucursal = [];
    if (pop_sel.sucursales_filtro)
      filtros_sucursal = JSON.parse(pop_sel.sucursales_filtro);
    if (medio_sel.sucursales_filtro)
      filtros_sucursal = [...filtros_sucursal, ...JSON.parse(medio_sel.sucursales_filtro)];
    const res_dt_totales: any = await this.inventoryService.getInventory(this.data.id_proy, this.data.id_proy_camp, this._cutoffS, medio_sel.id, pop_sel.id, filtros_sucursal, this.data.selected_attributes);
    let dt_totales_filtered: any[];
    if (medio_sel.inventario_type == 1) {
      dt_totales_filtered = res_dt_totales.filter((rd: any) => rd.id_medio == medio_sel.id && rd.id_pop == pop_sel.id);
    }
    else {
      dt_totales_filtered = res_dt_totales.filter((rd: any) => rd.id_medio == medio_sel.id && rd.id_pop == pop_sel.id);
    }
    const dt_totales_sum = dt_totales_filtered.reduce((acc: any, item: any) => {
      const key = item.atributo;
      if (!acc[key]) {
        acc[key] = { ...item, inventario: 0, disponible: 0, items: [] };
      }
      acc[key].inventario += Number(item.inventario || 0);
      acc[key].disponible += Number(item.disponible || 0);
      acc[key].items.push(item);
      return acc;
    }, {});
    const dt_totales_processed = Object.values(dt_totales_sum);
    return {
      dt_totales: dt_totales_processed,
      dt_totales_validation: dt_totales_processed
    };
  }

  isEmpyConfig(json: any): boolean {
    let empyconfig = true;
    try {
      if (JSON.parse(json)[0].id > 0) {
        empyconfig = false;
      }
    } catch (ex) { }
    return empyconfig;
  }

  async processSucursalesForDiagram(diagram: any): Promise<{
    stores_sel: any[];
    alerts: string[];
    dt_totales: any[];
  }> {
    const pop_sel = diagram.pop_sel;
    const medio_sel = diagram.medio_sel;
    const alerts: string[] = [];
    const { dt_totales } = await this.getInventoryForDiagram(medio_sel, pop_sel);
    const popConfigs: any = await this.projectsS.getPOPConfigs(pop_sel.id).toPromise();
    console.log("POP Configs:", popConfigs);
    const materiales_dist = popConfigs.data.configs;
    const arr_reglas = materiales_dist.map((config: any) => {
      let r: any = {};
      if (medio_sel.formato == 3) {
        r = JSON.parse(medio_sel.prioridad_filtro)[0];
        r.cant_type = 4; // de por maximos
      }
      else if (medio_sel.formato == 2) {
        r = JSON.parse(medio_sel.prioridad_filtro)[0];
        r.cant_type = 3;
      }
      else if (!config.reglas_distribucion || config.reglas_distribucion.length == 0 || config.reglas_distribucion == "[]" || this.isEmpyConfig(config.reglas_distribucion)) {
        r = { cant_type: 1, multiplicador: config.cantidad, nombre: config.nombre };
      }
      else {
        r = JSON.parse(config.reglas_distribucion)[0];
        r.cant_type = 2;
      }
      r.inventario_type = medio_sel.inventario_type;
      r.atributo = r.nombre;
      r.prioridad = pop_sel.prioridad;
      r.nombre = r.inventario_type == 1 ? medio_sel.nombre : (r.inventario_type == 2 ? pop_sel.nombre : (r.inventario_type == 3 ? config.nombre : r.atributo));
      r.id_pop_config = config.id;
      return r;
    });
    const arr_cant = arr_reglas
      .filter((e: any) => e.nombre)
      .map((e: any) => ({
      id_pc: e.id_pop_config,
      nombre: e.nombre,
      atributo: e.atributo,
      cantidad: Number(e.multiplicador),
      tipo: e.cant_type
    }));
    let filtros: any = [];
    if (pop_sel.sucursales_filtro)
      filtros = JSON.parse(pop_sel.sucursales_filtro);
    if (medio_sel.sucursales_filtro)
      filtros = [...filtros, ...JSON.parse(medio_sel.sucursales_filtro)];
    let storeFile = this._cutoffS.filtrarSucursales(filtros);
    const samePopDiagrams = this.projectAllDiagramations.filter((existing: any) => existing.id_medio == medio_sel.id && existing.id_pop == pop_sel.id);
    const sameStores = samePopDiagrams.length > 0; // Si ya existe una diagramación con el mismo medio y POP, se consideran las mismas sucursales, antes estaba ignoranto esto
    if ((medio_sel.formato === 3 || medio_sel.formato === 2)) {
      const file_suc_full = this._cutoffS.project_cutoff_file_data;
      let ids_suc_sel = this.projectAllDiagramations.filter((e: any) => e.id_medio == medio_sel.id);
      if (medio_sel.inventario_type != 1 || medio_sel.formato === 2) {
        ids_suc_sel = ids_suc_sel.filter((e: any) => e.id_pop == pop_sel.id);
      }
      //flat transforma el arreglo de arreglos en un solo arreglo
      ids_suc_sel = ids_suc_sel.map((d: any) => d.pop_config.map((pc: any) => pc.sucursales.map((s: any) => s.id)).flat()).flat();
      //flamap transforma el arreglo de arreglos en un solo arreglo y lo mapea a un nuevo arreglos
      const sucursalCantidadMap = this.projectAllDiagramations
        .filter((existing: any) => existing.id_medio == medio_sel.id)
        .flatMap((existing: any) => existing.pop_config.flatMap((config: any) => config.sucursales.map((sucursal: any) => ({
        id: sucursal.id,
        cantidad: Number(sucursal.cantidad),
        key: "" + existing.id_pop + "-" + sucursal.id
      }))))
        .reduce((acc: {
        quantities: Record<number, number>;
        seenPops: Set<string>;
      }, item: any) => {
        if (medio_sel.formato !== 3 || !acc.seenPops.has(item.key)) {
          acc.seenPops.add(item.key);
          acc.quantities[item.id] = (acc.quantities[item.id] || 0) + item.cantidad;
        }
        return acc;
      }, { quantities: {}, seenPops: new Set<string>() }).quantities;
      let invalidStoreIds: number[] = [];
      if (medio_sel.formato === 2) {
        invalidStoreIds = ids_suc_sel.filter((id: number) => {
          const sucursal = file_suc_full.find((s: any) => s.id === id);
          if (!sucursal)
            return false;
          const attribute = Object.keys(sucursal).find(key => key.includes(arr_reglas[0]?.atributo));
          return !!attribute && sucursalCantidadMap[id] > Number(sucursal[attribute]);
        });
      }
      if (!sameStores) {
        if (medio_sel.formato === 3) {
          const maxRule = arr_reglas.find((reg: any) => reg.cant_type === 4);
          invalidStoreIds = ids_suc_sel.filter((id: number) => {
            const sucursal = file_suc_full.find((s: any) => s.id === id);
            if (!sucursal)
              return false;
            const attribute = Object.keys(sucursal).find(key => key.includes(maxRule?.atributo));
            return !!attribute && sucursalCantidadMap[id] >= Number(sucursal[attribute]);
          });
        }
        storeFile = storeFile.filter((store: any) => !invalidStoreIds.includes(store.id));
        const rule = arr_reglas.find((reg: any) => reg.cant_type === (medio_sel.formato === 2 ? 3 : 4));
        if (rule) {
          storeFile = storeFile.filter((store: any) => Number(store[rule.atributo]) > 0);
        }
      }
    }
    if (!sameStores && medio_sel.multiples_elementos == 0) {
      const ids_suc_sel_aux = this.projectAllDiagramations.filter((e: any) => e.id_medio == medio_sel.id && e.id !== diagram.id).map((d: any) => d.pop_config.map((pc: any) => pc.sucursales.map((s: any) => s.id)).flat()).flat();
      if (ids_suc_sel_aux.length > 0)
        storeFile = storeFile.filter((e: any) => !ids_suc_sel_aux.includes(e.id));
    }
    if (sameStores) {
      return {
        stores_sel: samePopDiagrams[0].pop_config.map((config: any) => ({
          id_pc: config.id_pop_config,
          sucursales: config.sucursales,
          total: config.cantidad
        })),
        alerts,
        dt_totales
      };
    }
    const availableStoreIds = new Set(storeFile.map((s: any) => Number(s.id)));
    const validSucursalesToSelect = diagram.sucursales.filter((id: number) => availableStoreIds.has(Number(id)));
    const invalidSucursales = diagram.sucursales.filter((id: number) => !availableStoreIds.has(Number(id)));
    if (invalidSucursales.length > 0) {
      alerts.push("Las siguientes sucursales no estaban disponibles y no fueron seleccionadas: " + invalidSucursales.join(", ") + ".");
    }
    if (validSucursalesToSelect.length === 0 && diagram.sucursales.length > 0) {
      return { stores_sel: [], alerts, dt_totales };
    }
    const sel_sf = validSucursalesToSelect.length > 0
      ? storeFile.filter((e: any) => validSucursalesToSelect.includes(Number(e.id)))
      : medio_sel.segmentable == 1
        ? []
        : storeFile;
    const stores_sel = arr_cant.map((e: any) => {
      const sucursales = sel_sf.map((sf: any) => {
        let cantidad = 0;
        if (e.tipo == 1) {
          cantidad = e.cantidad;
        }
        else if (e.tipo == 2) {
          cantidad = (sf[e.atributo] ? parseInt(sf[e.atributo]) : 0) * e.cantidad;
        }
        else if (e.tipo == 3) {
          const cant_pops = Number(diagram.cant_pops);
          if (!cant_pops) {
            throw new Error("No se pudo determinar la cantidad de POPs del medio \"" + medio_sel.nombre + "\".");
          }
          const cant_total_suc = (sf[e.atributo] ? parseInt(sf[e.atributo]) : 0) * e.cantidad;
          const modulo = cant_total_suc % cant_pops;
          const max = Math.ceil(cant_total_suc / cant_pops);
          const min = Math.floor(cant_total_suc / cant_pops);
          cantidad = Number(pop_sel.prioridad <= modulo ? max : min);
        }
        else if (e.tipo == 4) {
          const diagramasCant = this.projectAllDiagramations.filter((existing: any) => existing.id_medio == medio_sel.id &&
            (medio_sel.inventario_type == 1 || existing.id_pop == pop_sel.id));
          const sucSeleccionads = diagramasCant
            .flatMap((existing: any) => existing.pop_config.flatMap((config: any) => config.sucursales
            .filter((sucursal: any) => sucursal.id == sf.id)
            .map((sucursal: any) => ({
            cantidad: Number(sucursal.cantidad),
            key: "" + existing.id_pop + "-" + sucursal.id
          }))))
            .reduce((acc: {
            total: number;
            seenPops: Set<string>;
          }, item: any) => {
            if (medio_sel.inventario_type != 1 || medio_sel.formato !== 3 || !acc.seenPops.has(item.key)) {
              acc.seenPops.add(item.key);
              acc.total += item.cantidad;
            }
            return acc;
          }, { total: 0, seenPops: new Set<string>() });
          const sumaSucursalTotal = sucSeleccionads.total;
          let maxValue = storeFile.find((x: any) => x.id == sf.id)?.[arr_reglas.find((reg: any) => reg.cant_type === 4)?.atributo] || 0;
          let valueToAdd = e.cantidad > maxValue ? maxValue : e.cantidad;
          cantidad = (sumaSucursalTotal + valueToAdd) > maxValue
            ? maxValue - sumaSucursalTotal
            : valueToAdd;
        }
        return cantidad > 0 ? { id: sf.id, cantidad } : null;
      }).filter((sucursal: any) => sucursal !== null);
      return {
        id_pc: e.id_pc,
        sucursales,
        total: sucursales.reduce((total: number, sucursal: any) => total + Number(sucursal.cantidad), 0)
      };
    }).filter((config: any) => config.sucursales.length > 0);
    return { stores_sel, alerts, dt_totales };
  }

  showDiagramAlerts(diagram: any) {
    if (diagram.alerts.length === 0)
      return;
    const alertList = diagram.alerts.map((alert: string) => "<li>" + alert + "</li>").join("");
    Swal.fire({
      title: "Alertas para " + (diagram.alias || "diagramación"),
      html: "<ul style=\"text-align: left; margin-left: 20px;\">" + alertList + "</ul>",
      icon: "warning",
      confirmButtonText: "Aceptar"
    });
  }

  showDiagramError(diagram: any) {
    if (!diagram.error)
      return;
    Swal.fire({
      title: "Error en " + (diagram.alias || "diagramación"),
      html: "<p style=\"text-align: left; margin-left: 20px;\">" + diagram.error + "</p>",
      icon: "error",
      confirmButtonText: "Aceptar"
    });
  }

  async validarGuardado(diagram: any, ins_data: any): Promise<any> {
    try {
      await this.refreshDataDiagramationAsync();
      const medio_sel = diagram.medio_sel;
      const pop_sel = diagram.pop_sel;
      const popsResponse: any = await this.projectsS.getPOPs(medio_sel.id).toPromise();
      const availableElements = this.availablePops(popsResponse.data.elementos_pop, medio_sel.id);
      if (!availableElements.some((p: any) => Number(p.id) === Number(pop_sel.id))) {
        return { isValid: false, message: "El POP \"" + pop_sel.nombre + "\" ya no está disponible para el medio \"" + medio_sel.nombre + "\".", isMediaType: true };
      }
      let diagramedPositions: any[] = [];
      if (pop_sel.posiciones > 0) {
        diagramedPositions = this.projectAllDiagramations
          .filter((x: any) => x.id_medio == medio_sel.id && x.id_pop == pop_sel.id)
          .map((p: any) => Number(p.posicion));
        if (!Number.isInteger(ins_data.position) || ins_data.position < 1 ||
          ins_data.position > Number(pop_sel.posiciones) || diagramedPositions.includes(ins_data.position)) {
          return { isValid: false, message: "La posición " + ins_data.position + " ya no está disponible.", isPositionError: true };
        }
      }
      const { dt_totales_validation } = await this.getInventoryForDiagram(medio_sel, pop_sel);
      const { stores_sel: availableSelection } = await this.processSucursalesForDiagram(diagram);
      const stores_sel = ins_data.sucursales;
      if (!stores_sel.length || stores_sel.some((s: any) => !s.sucursales.length ||
        s.sucursales.some((store: any) => !Number.isFinite(Number(store.cantidad)) || Number(store.cantidad) <= 0))) {
        return { isValid: false, message: "Las cantidades de las sucursales deben ser números positivos." };
      }
      // validar las mismas sucursales y cantidades que se enviaran al guardar
      for (const sel of stores_sel) {
        const available = availableSelection.find((s: any) => Number(s.id_pc) === Number(sel.id_pc));
        if (!available || sel.sucursales.some((s: any) => !available.sucursales.some((a: any) => Number(a.id) === Number(s.id) && Number(a.cantidad) === Number(s.cantidad)))) {
          return { isValid: false, message: "La disponibilidad de sucursales o cantidades cambió. Intente importar nuevamente." };
        }
      }
      //aqui validamos si tiene mas posiciones
      if (diagramedPositions.length === 0) {
        const inventoryError = stores_sel
          .map((sel: any) => {
          const mediaInv = dt_totales_validation.find((dt: any) => dt.items.some((item: any) => item.id_pop_config == sel.id_pc));
          if (!mediaInv) {
            return "No se encontró información de inventario para el material: " + sel.id_pc + ".";
          }
          const inventoryInfo = mediaInv.items.find((item: any) => item.id_pop_config == sel.id_pc);
          if (!inventoryInfo) {
            return "No se encontró información de inventario para el material: " + sel.id_pc + ".";
          }
          const currentSelectedTotal = sel.sucursales.reduce((sum: number, s: any) => sum + Number(s.cantidad), 0);
          const totalPreviouslySelected = Number(inventoryInfo.seleccionado || 0);
          const inventarioReal = Number(medio_sel.formato == 1 ? mediaInv.inventario : inventoryInfo.inventario);
          return (currentSelectedTotal + totalPreviouslySelected) > inventarioReal
            ? "La cantidad para \"" + inventoryInfo.nombre + "\" (" + currentSelectedTotal + ") excede el inventario disponible (" + (inventarioReal - totalPreviouslySelected) + ")."
            : null;
        })
          .find((message: string | null) => message !== null);
        if (inventoryError) {
          return { isValid: false, message: inventoryError };
        }
      }
      return { isValid: true };
    } catch (error: any) {
      console.error("Error en validación de guardado:", error);
      return { isValid: false, message: error.message || "Error inesperado durante la validación." };
    }
  }

  async revalidarGuardado(diagram: any, ins_data: any, id_diagrama: number): Promise<any> {
    try {
      await this.refreshDataDiagramationAsync();
      const medio_sel = diagram.medio_sel;
      const pop_sel = diagram.pop_sel;
      const { dt_totales_validation } = await this.getInventoryForDiagram(medio_sel, pop_sel);
      const stores_sel = ins_data.sucursales;
      const otherDiagramations = this.projectAllDiagramations.filter((x: any) => x.id_medio == medio_sel.id && x.id_pop == pop_sel.id && x.id != id_diagrama);
      const diagramedPositions = otherDiagramations.map((p: any) => Number(p.posicion));
      if (pop_sel.posiciones > 0 && diagramedPositions.includes(ins_data.position)) {
        return {
          isValid: false, message: "Conflicto de inventario para " + pop_sel.nombre + ", ya existe una diagramación con estos datos."
        };
      }
      if (diagramedPositions.length === 0) {
        for (const sel of stores_sel) {
          const mediaInv = dt_totales_validation.find((dt: any) => dt.items.some((c: any) => c.id_pop_config == sel.id_pc));
          if (mediaInv) {
            const inventoryInfo = mediaInv.items.find((dt: any) => dt.id_pop_config == sel.id_pc);
            if (inventoryInfo) {
              const totalPreviouslySelected = Number(inventoryInfo.seleccionado || 0);
              const inventarioReal = Number((medio_sel.formato == 1) ? mediaInv.inventario : inventoryInfo.inventario);
              if (totalPreviouslySelected > inventarioReal) {
                return {
                  isValid: false, message: "Conflicto de inventario para " + inventoryInfo.nombre + ": lo seleccionado (" + totalPreviouslySelected + ") excede el inventario disponible (" + inventarioReal + ")."
                };
              }
            }
            else {
              return {
                isValid: false, message: "No se encontró información de inventario para el material: " + sel.id_pc + "."
              };
            }
          }
          else {
            return {
              isValid: false,
              message: "No se encontró información de inventario para el material: " + sel.id_pc + "."
            };
          }
        }
      }
      return { isValid: true, message: "La selección es válida." };
    } catch (error: any) {
      console.error("Error en re-validación:", error);
      return { isValid: false, message: error.message || "Error inesperado durante la re-validación." };
    }
  }

  async refreshDataDiagramationAsync(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.projectsS.getProjectConfig(this.data.id_proy).subscribe({
        next: (x: any) => {
          this.projectAllDiagramations = x.data.diagram_all;
          resolve();
        },
        error: (err: any) => {
          console.error("Error refreshing diagramation data:", err);
          reject(err);
        }
      });
    });
  }

  showSummary() {
    const summaryDialog = this.matDialog.open(ProjectDiagramationImportSummaryComponent, {
      panelClass: ["dialogs-xl"],
      data: {
        diagrams: this.diagrams,
        projectData: this.project,
        promos: this.promos,
        phases: this.phases,
        id_proy: this.data.id_proy,
        id_proy_camp: this.data.id_proy_camp,
        projectAllDiagramations: this.projectAllDiagramations,
        selected_medios: this.selected_medios,
        selected_attributes: this.data.selected_attributes,
        stopOnError: this.stopOnError
      },
      disableClose: true
    });
    summaryDialog.afterClosed().subscribe(async (result) => {
      if (result?.retryDiagrams) {
        this.diagrams = result.retryDiagrams;
        this.importCompleted = false;
        this.isImporting = false;
        try {
          await this.refreshDataDiagramationAsync();
          await this.processImportedData();
        } catch (error) {
          Swal.fire("Error", "No se pudo actualizar el proyecto. Cierre e intente nuevamente.", "error");
        }
      }
      else if (result?.reload) {
        this.dialogRef.close({ reload: true });
      }
    });
  }
}
